module.exports = __webpack_public_path__ + "img/kangxinsticky.307a7248.png";